import 'rc-calendar/assets/index.css';
import React from 'react';
import Calendar from 'rc-calendar';
import zhTW from './rc-calendar/zh_TW.js';
import moment from 'moment';

export default (
  <Calendar
    locale={zhTW}
    dateInputPlaceholder="請選擇日期"
    formatter="YYYY-MM-DD"
    defaultValue={moment()}
    showDateInput />
);



// WEBPACK FOOTER //
// ./libs/Calendar.js